<template>
  <div class="feedback-view">
    <NavBar/>
    <feedback/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar';
  import feedback from '@/components/FeedbackPage'

  export default {
    name: 'FeedbackView',

    components: {
      NavBar,
      feedback,
    },
  }
</script>

<style lang="scss" scoped>
.feedback-view {
  min-height: 100vh;
}
</style>